var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLink = function SvgLink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00105 15.5018L15.0011 9.50097M11.0011 6.50057L11.4641 5.9645C12.4019 5.0267 13.6738 4.49991 15 4.5C16.3262 4.50009 17.598 5.02707 18.5357 5.965C19.4734 6.90293 20.0001 8.17498 20 9.50132C19.9999 10.8277 19.473 12.0996 18.5352 13.0374L18.0012 13.5015M13.0011 18.5022L12.6041 19.0362C11.6551 19.9741 10.3747 20.5 9.04055 20.5C7.7064 20.5 6.42602 19.9741 5.47701 19.0362C5.00911 18.5739 4.63763 18.0233 4.38409 17.4163C4.13055 16.8094 4 16.1581 4 15.5003C4 14.8425 4.13055 14.1912 4.38409 13.5842C4.63763 12.9772 5.00911 12.4266 5.47701 11.9643L6.00101 11.5012",
    stroke: "#5547DD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Link.163b2a133e9e522342dffec52f7c7bc3.svg";